import apiFetch from '@/store/helpers/api-fetch'
import { ChevronLeft, HomeIcon, Loader2 } from 'lucide-react'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import useSWRImmutable from 'swr/immutable'
import CommunityDisplay from './community-display'
import EditContent from './edit-content'
import ManageContent from './manage-content'

export default function ChampionshipSidebar({
  pathname,
  params,
  session,
  serverInfoFeatureEnabled,
}) {
  const router = useRouter()

  const { championshipId } = params

  const { data: community, isLoading } = useSWRImmutable(
    {
      url: `community/${params.communityId}`,
      searchParams: {
            select: {
              id: true,
              name: true,
              logoImgUrl: true,
          isShowcase: true,
          championships: {
            where: {
              deleteTs: null,
            },
            select: {
              id: true,
              name: true,
              headerImgUrl: true,
              isSingleEvent: true,
              isWhitelistOnly: true,
            },
          },
        },
      },
    },
    apiFetch,
  )

  const { data: pendingApplications } = useSWRImmutable(
    community
      ? {
          url: `community/${params.communityId}/championship/${championshipId}/attendee`,
          searchParams: {
            where: {
              status: 'pending',
              role: {
                in: ['driver', 'reserve'],
              },
            },
          },
        }
      : null,
    apiFetch,
  )

  const hasOutstandingApplications =
    pendingApplications && pendingApplications.length > 0

  const currentChampionship = community?.championships?.find(
    (championship) => championship.id === championshipId,
  )

  return (
    <>
      <div className="flex flex-col max-tablet:hidden">
        {(pathname.includes('edit') || pathname.includes('create')) && (
          <Link
            href={`/manage/${params.communityId}/racing/${params.championshipId}`}
            className="mb-6 flex items-center gap-1"
          >
            <ChevronLeft className="size-6 stroke-neutral-blue-400" />
            <p className="text-p-1 font-semibold text-neutral-blue-400 desktop-xs:text-p-3">
              {isLoading ? (
                <>
                  Back to <Loader2 className="inline size-4 animate-spin" />
                </>
              ) : (
                `Back to ${currentChampionship?.isSingleEvent ? 'Single Event' : 'Championship'}`
              )}
            </p>
          </Link>
        )}

        <CommunityDisplay
          community={community}
          communityLoading={isLoading}
          session={session}
        />

        <p className="mb-2 mt-5 text-p-1 font-bold text-neutral-blue-400">
          Community
        </p>

        <Link
          href={`/manage/${params.communityId}/racing`}
          className="mb-3 mt-1 flex items-center gap-2 rounded-sm p-2 transition-all hover:bg-neutral-blue-600"
        >
          <div className="flex aspect-square items-center justify-center rounded-sm bg-neutral-blue-700 stroke-neutral-blue-200 p-1">
            <HomeIcon className="size-5" />
          </div>
          <p className="text-p-1 font-bold">Home</p>
        </Link>

        <div className="divide mb-4 mt-2 bg-neutral-blue-700"></div>
      </div>

      {!pathname.includes('edit') && !pathname.includes('create') && (
        <ManageContent
          params={params}
          pathname={pathname}
          router={router}
          community={community}
          hasOutstandingApplications={hasOutstandingApplications}
        />
      )}

      {pathname.includes('edit') && (
        <EditContent
          params={params}
          pathname={pathname}
          router={router}
          serverInfoFeatureEnabled={serverInfoFeatureEnabled}
        />
      )}
    </>
  )
}
